import { useEffect } from "react"
import { useParams, useHistory } from "react-router"

import { Params } from "pages/learn/landing/components/post-summary-list"

export const useRedirect = (pages: number, postUrl: boolean) => {
  const { path, page, section } = useParams<Params>()
  const history = useHistory()

  useEffect(() => {
    if (postUrl) {
      return
    }

    if (!section) {
      return
    }

    const pageFromSection = Number(section)
    if (section !== "section" && (isNaN(pageFromSection) || pageFromSection > pages)) {
      history.push("/learn/1")
      return
    }

    if (!page) {
      return
    }

    const pageFromUrl = Number(page)
    if (isNaN(pageFromUrl) || pageFromUrl > pages) {
      history.push(`/learn/section/${path}/1`)
      return
    }
  }, [page])
}
